import globalStore from './model';

export const getGlobalStore = globalStore;

export const isLoading = () => {
  const { loading } = globalStore();
  return loading;
};

export const error = () => {
  const globalStoreData = globalStore();
  return globalStoreData.error;
};
